var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{ 'toggle-button': !_vm.isMini, 'toggle-button-mini': _vm.isMini }},[_c('input',{attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"value":_vm.initialData},on:{"click":function($event){$event.preventDefault();return _vm.toggleChange($event)}}}),_c('span',{class:{
      'on-off-dim-toggle': _vm.isDim && !_vm.isMini,
      'on-off-toggle': !_vm.isDim && !_vm.isMini,
      'on-off-dim-toggle-mini': _vm.isDim && _vm.isMini,
      'on-off-toggle-mini': !_vm.isDim && _vm.isMini,
      checked: _vm.initialData,
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }